import { Button } from '@heroui/react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex } from '../Flex';
import { Code, ErrorDescription, ErrorTitle, ErrorWrapper, IconWrapper } from './ContentLoadError.styled';

interface ContentLoadErrorProps {
    onRefreshClicked?: () => void;
    message?: string | null;
    title?: string;
    code?: string;
}

export const ContentLoadError: FC<ContentLoadErrorProps> = ({
  onRefreshClicked,
  message,
  title,
  code,
}) => {
  const { t } = useTranslation();

  return (
    <ErrorWrapper>
      <Flex gap="20px" itemAlign="center" justifyContent="center" direction="column" fullHeight>
        {/* Icon with animation */}
        <IconWrapper>
          <AlertCircle size={48} />
        </IconWrapper>

        {/* Title */}
        <ErrorTitle>{title || t('errors.loadFailed')}</ErrorTitle>

        {/* Error code badge */}
        {code && <Code>{code}</Code>}

        {/* Description */}
        <ErrorDescription>
          {message || t('errors.loadFailedDescription')}
        </ErrorDescription>

        {/* Action button */}
        {onRefreshClicked && (
        <Button
          onPress={onRefreshClicked}
          color="primary"
          radius="lg"
          size="lg"
          variant="shadow"
          startContent={<RefreshCw size={18} />}
          className="font-light"
        >
          {t('common.tryAgain')}
        </Button>
        )}
      </Flex>
    </ErrorWrapper>
  );
};
